import StackdriverErrorReporter from 'stackdriver-errors-js';
import { getEnvironment, isHostedEnvironment } from './config';
import { NodeEnv } from '@/enums';

const errorHandler = new StackdriverErrorReporter();
const apiKey = 'AIzaSyAn1_aqCVLZvlLo69t-LPRPx8QP89A347E';

/**
 * Starts observing for unchecked errors and unhandled promise rejections and sends them
 * to Google Cloud Error Reporting.
 */
export const startReportingErrors = () => {
  if (process.env.NODE_ENV === NodeEnv.DEVELOPMENT) return;

  errorHandler.start({
    targetUrl: isHostedEnvironment()
      ? `/server/error-reporting?key=${apiKey}`
      : `http://localhost:8080/error-reporting?key=${apiKey}`,
    projectId: 'a2i2-living-knowledge',
    service: `${getEnvironment()}-web`,
    version: process.env.VUE_APP_VERSION || 'local',
  });
};

/**
 * Sends an error to Google Cloud Error Reporting.
 * Use this when the exception is handled but you still want to report it.
 */
export const reportError = (error) => {
  if (process.env.NODE_ENV === NodeEnv.DEVELOPMENT) return;

  // eslint-disable-next-line no-console
  console.error(error);

  // Skip 2 frames to get to the actual error.
  errorHandler.report(error, { skipLocalFrames: 2 });
};

/**
 * Sets the user ID to be used in Google Cloud Error Reporting.
 * @param {string} userId - The user ID.
 */
export const setUserIdForErrorReporting = (userId) => {
  if (process.env.NODE_ENV === NodeEnv.DEVELOPMENT) return;

  errorHandler?.setUser(userId);
};
